<template>
  <section class="body">
    <div>
      <label class="picker__label">
        Selecciona las colas a las cuáles se podrán transferir tickets (Opcional)
        <a-tooltip title="Información">
          <InfoCircleOutlined class="picker__icon" />
        </a-tooltip>
      </label>
      <selector-queues :value="queues" @update:value="queues = $event" :height="332" />
    </div>
  </section>
</template>

<script>
import SelectorQueues from "@/app/shared/components/selectors/SelectorQueues.vue";
import { defineComponent } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    SelectorQueues,
    InfoCircleOutlined,
  },
  computed: {
    queues: {
      get() {
        return this.$store.getters["getQueueState"].allowed_queues;
      },
      set(allowed_queues) {
        this.$store.dispatch("setQueueProperties", { allowed_queues });
      },
    },
  },
  methods: {
    async handleOk() {
      await this.$store.dispatch("createNewQueue");
      await this.$store.dispatch("fetchAllQueues");
      return null;
    },
  },
});
</script>

<style lang="sass" scoped>
.body
  gap: 32px
  display: grid
  grid-template-columns: 0.5fr 2fr 0.5fr

  & div
    grid-column: 2

.picker
  &__label
    display: block
    margin-bottom: 8px

  &__icon
    margin: 4px 0 0 4px
</style>
